module.exports = __webpack_public_path__ + "img/sphtx.9b35fbc5.svg";